import { QuoteSheetTable } from '@/components/procurement/quote-sheet-table/QuoteSheetTable';
import Page from '@/components/page/Page';
import { Outlet } from '@tanstack/react-router';

export function PriceQuoteSheetDashboard() {
  return (
    <Page title="Daily Commodity Prices">
      <QuoteSheetTable />
      <Outlet />
    </Page>
  );
}
